export const firebaseConfig = {
  apiKey: "AIzaSyD9Xbpp0mTO7No882DsS8boghkJLa7hzRA",
  authDomain: "crew-stg.firebaseapp.com",
  projectId: "crew-stg",
  storageBucket: "crew-stg.appspot.com",
  messagingSenderId: "922181321502",
  appId: "1:922181321502:web:7155bbbf27880f5a08ff0f"
};